var _rect, _rect2, _rect3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisabledSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 5,
    viewBox: "0 0 20 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "url(#paint0_linear_1207_45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "url(#paint1_linear_1207_45)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "url(#paint2_linear_1207_45)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1207_45",
    x1: 2.5,
    y1: 0,
    x2: 2.5,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5765"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1207_45",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5765"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1207_45",
    x1: 17.5,
    y1: 0,
    x2: 17.5,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5765"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledSendIcon);
export default __webpack_public_path__ + "static/media/disabled-send-icon.4ce5cc2314014c577b0602fb3658cda2.svg";
export { ForwardRef as ReactComponent };